export default "__VITE_ASSET__Cu0ZU6wW__"